<section class="view-afiliados mb-5">
  <div class="row m-0 header justify-content-center text-center">
    <h1 class="title">
      {{ socio?.nombreCompleto }} {{ socio?.apellidoPat }}
      {{ socio?.apellidoMat }}
    </h1>
  </div>
  <div class="row mt-3 mt-md-5 mx-3 mx-md-0">
    <div class="col-md-2 col-0"></div>
    <div class="col-12 col-md-8 justify-content-center text-center">
      <!-- Afiliado starts -->

      <div class="afiliado" *ngIf="socio">
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col">
                    <img
                      height="300"
                      width="auto"
                      [src]="imgUri"
                      [alt]="socio?.nombreCompleto"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 text-left mt-5">
                <div class="row">
                  <div class="col">
                    <p class="text">
                      <span class="label">Correo:</span>
                      {{ socio?.correoElectronico }}
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <p class="text">
                      <span class="label">Teléfono Fijo:</span>
                      {{ socio?.telefonoFijo }}
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <p class="text">
                      <span class="label">Teléfono Móvil:</span>
                      {{ socio?.telefonoMovil }}
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <p class="text">
                      <span class="label">Dirección:</span>
                      {{ socio?.calle }} #{{ socio?.numero }}, C.P.
                      {{ socio?.codigoPostal }}, Col. {{ socio?.colonia }},
                      {{ socio?.ciudad }},
                      {{ socio?.estado }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <span class="text label">Currículum Vitae:</span>
                <p class="text text-justify">
                  {{ socio?.curriculumVitae }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-light text-center" *ngIf="loading">
        <h4 class="alert-heading">Cargando</h4>
        <p class="d-flex justify-content-center">
          <mat-spinner diameter="50" mode="indeterminate"></mat-spinner>
        </p>
        <p class="mb-0">Espere por favor</p>
      </div>

      <!-- Afiliado ends -->
    </div>
    <div class="col-md-2 col-0"></div>
  </div>
</section>
